.timer-container{border-radius:34px;padding:8px}.timer-container.alert-info{background-color:#5a42d014}.timer-container.alert-warning{background-color:#ffa71d26}.timer-container.alert-danger{background-color:#e31c3d1f}
/*# sourceMappingURL=timer-badge.component.css.map */
